
import BotonWhatsapp from "../components/BotonWhatsapp";

function Planes() {
  const planes = [
    {
      nombre: "Plan Básico",
      precio: 15.39,
      velocidad: "400 Mbps",
      descripcion: "Perfecto para navegación y streaming básico",
      caracteristicas: [
        "400 Mbps de velocidad real",
        "Instalación completamente gratuita",
        "Router WiFi profesional incluido",
        "Soporte técnico local en Pujilí",
        
        "Ideal para 3-4 dispositivos"
      ],
      popular: false,
      color: "blue",
      uso: "Hogar básico"
    },
    {
      nombre: "Plan Estudiante",
      precio: 17.70,
      velocidad: "600 Mbps",
      descripcion: "Diseñado especialmente para estudiantes",
      caracteristicas: [
        "600 Mbps para estudios online",
        "Perfecto para Zoom y Teams",
        "Descarga rápida de archivos",
        "Streaming HD sin interrupciones",
        "Múltiples dispositivos simultáneos",
        "Soporte prioritario para estudiantes"
      ],
      popular: true,
      color: "green",
      uso: "Estudiantes"
    },
    {
      nombre: "Plan Tecnología",
      precio: 23.30,
      velocidad: "800 Mbps",
      descripcion: "Para profesionales y trabajo remoto",
      caracteristicas: [
        "800 Mbps profesionales",
        "Ideal para trabajo remoto",
        "Videoconferencias en 4K",
        "Streaming simultáneo múltiple",
        "Gaming online fluido",
        "Sin límites de descarga ni reducción de velocidad."
      ],
      popular: false,
      color: "purple",
      uso: "Profesionales"
    },
    {
      nombre: "Plan Gamer",
      precio: 30.60,
      velocidad: "1000 Mbps",
      descripcion: "Máxima velocidad para gaming y streaming",
      caracteristicas: [
        "1 Gigabit completo (1000 Mbps)",
        "Latencia ultra baja para gaming",
        "Streaming en 4K sin problemas",
        "Descargas instantáneas",
        "Soporte para streamers",
        "Router gaming especializado"
      ],
      popular: false,
      color: "red",
      uso: "Gamers Pro"
    }
  ];

  const getColorClasses = (color, isPopular) => {
    const colors = {
      blue: isPopular ? "border-blue-500 bg-blue-50" : "border-gray-200",
      green: isPopular ? "border-green-500 bg-green-50" : "border-gray-200",
      purple: isPopular ? "border-purple-500 bg-purple-50" : "border-gray-200",
      red: isPopular ? "border-red-500 bg-red-50" : "border-gray-200"
    };
    return colors[color];
  };

  const getButtonColor = (color) => {
    const colors = {
      blue: "bg-blue-600 hover:bg-blue-700",
      green: "bg-green-600 hover:bg-green-700",
      purple: "bg-purple-600 hover:bg-purple-700",
      red: "bg-red-600 hover:bg-red-700"
    };
    return colors[color];
  };

  return (
    <div>
      
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20 mt-16">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Planes Promocionales por 3 Meses
          </h1>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            🎉 <strong>¡OFERTA ESPECIAL EN PUJILÍ!</strong> Velocidades ultra rápidas 
            desde 400 Mbps hasta 1 Gigabit completo. Precios únicos por tiempo limitado.
          </p>
          <div className="bg-yellow-400 text-gray-800 p-4 rounded-lg inline-block mb-8">
            <p className="text-lg font-bold">
              ⚡ Promoción válida solo por 3 meses ⚡
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:0998106377"
              className="bg-green-500 hover:bg-green-600 text-white px-8 py-3 rounded-lg font-semibold transition-colors"
            >
              📞 Llamar: 099 810 6377
            </a>
            <a 
              href="https://wa.me/593998106377?text=Quiero información sobre los planes promocionales en Pujilí"
              className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold transition-colors"
            >
              💬 WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* Planes Grid */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              Elige tu Plan Promocional
            </h2>
            <p className="text-lg text-gray-600">
              Instalación gratuita • Soporte local en Pujilí • Sin permanencia mínima
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {planes.map((plan, index) => (
              <div 
                key={index}
                className={`bg-white rounded-lg shadow-lg p-6 text-center border-2 relative ${getColorClasses(plan.color, plan.popular)} hover:shadow-xl transition-shadow`}
              >
                {plan.popular && (
                  <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-1 rounded-full text-sm font-semibold">
                    ⭐ Más Popular
                  </div>
                )}
                
                <div className="mb-4">
                  <span className="text-sm bg-gray-100 text-gray-600 px-2 py-1 rounded-full">
                    {plan.uso}
                  </span>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-800 mb-2">{plan.nombre}</h3>
                <div className="text-4xl font-bold text-blue-600 mb-1">${plan.precio}</div>
                <div className="text-gray-600 mb-3">por mes (3 meses)</div>
                <div className="text-2xl font-bold text-green-600 mb-4">{plan.velocidad}</div>
                <p className="text-gray-600 text-sm mb-6">{plan.descripcion}</p>
                
                <ul className="text-left space-y-2 mb-8">
                  {plan.caracteristicas.map((caracteristica, idx) => (
                    <li key={idx} className="flex items-start">
                      <span className="text-green-500 mr-2 mt-1 text-sm">✓</span>
                      <span className="text-gray-700 text-sm">{caracteristica}</span>
                    </li>
                  ))}
                </ul>
                
                <div className="space-y-3">
                  <a 
                    href={`https://wa.me/593998106377?text=¡Hola! Me interesa el ${plan.nombre} promocional de $${plan.precio} con ${plan.velocidad} en Pujilí`}
                    className={`w-full text-white py-3 px-4 rounded-lg font-semibold transition-colors inline-block text-sm ${getButtonColor(plan.color)}`}
                  >
                    💬 Contratar por WhatsApp
                  </a>
                  <a 
                    href="tel:0998106377"
                    className="w-full bg-gray-600 hover:bg-gray-700 text-white py-2 px-4 rounded-lg font-semibold transition-colors inline-block text-sm"
                  >
                    📞 Llamar
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Comparación de Velocidades */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
            ¿Qué Puedes Hacer con Cada Velocidad?
          </h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-lg shadow-md p-6 text-center border-l-4 border-blue-500">
              <div className="text-3xl mb-4">🏠</div>
              <h3 className="text-lg font-semibold mb-2">400 Mbps</h3>
              <p className="text-sm text-gray-600 mb-4">Plan Básico</p>
              <ul className="text-xs text-gray-600 space-y-1">
                <li>• Netflix HD en 3 dispositivos</li>
                <li>• Videollamadas Zoom/Teams</li>
                <li>• Navegación súper rápida</li>
                <li>• Descargas de 1GB en 20 seg</li>
              </ul>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6 text-center border-l-4 border-green-500">
              <div className="text-3xl mb-4">🎓</div>
              <h3 className="text-lg font-semibold mb-2">600 Mbps</h3>
              <p className="text-sm text-gray-600 mb-4">Plan Estudiante</p>
              <ul className="text-xs text-gray-600 space-y-1">
                <li>• Clases online sin lag</li>
                <li>• Múltiples estudiantes</li>
                <li>• Descarga de libros instantánea</li>
                <li>• Streaming educativo 4K</li>
              </ul>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6 text-center border-l-4 border-purple-500">
              <div className="text-3xl mb-4">💼</div>
              <h3 className="text-lg font-semibold mb-2">800 Mbps</h3>
              <p className="text-sm text-gray-600 mb-4">Plan Tecnología</p>
              <ul className="text-xs text-gray-600 space-y-1">
                <li>• Trabajo remoto profesional</li>
                <li>• Videoconferencias 4K</li>
                <li>• Backup en la nube rápido</li>
                <li>• Streaming múltiple</li>
              </ul>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6 text-center border-l-4 border-red-500">
              <div className="text-3xl mb-4">🎮</div>
              <h3 className="text-lg font-semibold mb-2">1000 Mbps</h3>
              <p className="text-sm text-gray-600 mb-4">Plan Gamer</p>
              <ul className="text-xs text-gray-600 space-y-1">
                <li>• Gaming sin lag (ping &lt;5ms)</li>
                <li>• Streaming en Twitch 4K</li>
                <li>• Descargas de juegos instantáneas</li>
                <li>• Toda la familia online</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Información Local */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
              ¿Por Qué Betalink en Pujilí?
            </h2>
            
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-xl font-semibold mb-4 text-blue-600">🏠 Empresa Local</h3>
                <p className="text-gray-600 mb-4">
                  Estamos ubicados en <strong>Calle Pichincha y Zoila Victoria</strong>, 
                  en el corazón de Pujilí. Conocemos las necesidades específicas de nuestra comunidad.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>✓ Atención presencial en nuestra oficina</li>
                  <li>✓ Técnicos locales de Pujilí</li>
                  <li>✓ Soporte en el mismo día</li>
                </ul>
              </div>
              
              <div className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-xl font-semibold mb-4 text-green-600">⚡ Instalación Express</h3>
                <p className="text-gray-600 mb-4">
                  Instalación <strong>el mismo día</strong> que contratas. 
                  Sin esperas, sin complicaciones, sin costos adicionales.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>✓ Instalación en 2-3 horas máximo</li>
                  <li>✓ Configuración completa incluida</li>
                  <li>✓ Router WiFi profesional gratis</li>
                </ul>
              </div>
              
              <div className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-xl font-semibold mb-4 text-purple-600">💰 Precios Únicos</h3>
                <p className="text-gray-600 mb-4">
                  Esta promoción de 3 meses es <strong>exclusiva de Pujilí</strong>. 
                  Velocidades premium a precios increíbles.
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>✓ Sin costos ocultos</li>
                  <li>✓ Compromiso que garantiza estabilidad de servicio</li>
                  <li>✓ Precio fijo durante la promoción</li>
                </ul>
              </div>
              
              <div className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-xl font-semibold mb-4 text-red-600">🛡️ Garantía Total</h3>
                <p className="text-gray-600 mb-4">
                  Garantizamos la velocidad que contratas. 
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>✓ Velocidad garantizada 24/7</li>
                  <li>✓ Soporte técnico sin costo</li>
                  <li>✓ Tu satisfacción es nuestra prioridad</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Específico de Pujilí */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
            Preguntas Frecuentes en Pujilí
          </h2>
          
          <div className="max-w-4xl mx-auto space-y-6">
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-lg font-semibold mb-2">¿Llegan a toda Pujilí?</h3>
              <p className="text-gray-600">
                Sí, tenemos cobertura en todo Pujilí urbano y estamos expandiendo 
                constantemente a sectores rurales. Llámanos para verificar cobertura específica.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-lg font-semibold mb-2">¿Qué incluye la instalación?</h3>
              <p className="text-gray-600">
                Instalación completamente gratuita: tendido de cable, router WiFi, 
                configuración de todos tus dispositivos y capacitación básica. Todo incluido.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-lg font-semibold mb-2">¿Cómo pago mi plan?</h3>
              <p className="text-gray-600">
                Puedes pagar en nuestra oficina (Pichincha y Zoila Victoria), transferencia bancaria, 
                o un técnico puede pasar a cobrar mensualmente.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-md p-6">
              <h3 className="text-lg font-semibold mb-2">¿Qué pasa después de los 3 meses promocionales?</h3>
              <p className="text-gray-600">
                Después de los 3 meses, pasas al precio regular. Pero siempre tendrás la opción 
                de cambiar de plan.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="bg-blue-600 text-white py-16">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-4">
            ¡Esta Promoción No Se Repetirá!
          </h2>
          <p className="text-xl mb-8">
            Solo por 3 meses • Solo en Pujilí • Velocidades desde 400 Mbps
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:0998106377"
              className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg font-semibold transition-colors"
            >
              📞 Llamar: 099 810 6377
            </a>
            <a 
              href="https://wa.me/593998106377?text=¡Quiero aprovechar la promoción de 3 meses en Pujilí!"
              className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold transition-colors"
            >
              💬 ¡Quiero la Promoción!
            </a>
          </div>
          
          <div className="mt-8 text-center">
            <p className="text-blue-200">
              📍 Visítanos: Calle Pichincha y Zoila Victoria, Pujilí
            </p>
          </div>
        </div>
      </section>

      <BotonWhatsapp />
    </div>
  );
}

export default Planes;